import React from "react";
import {CloseButton} from "./ActionButtons"; // Ensure correct path for CloseButton import
import "./Styles/PopupWindow.css";

const PopupWindow = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
      >
        {/* CloseButton positioned at top-right corner of popup-container */}
        <CloseButton className="popup-close-button" color="#444" onClick={onClose} />
        {children}
      </div>
    </div>
  );
};

export default PopupWindow;
